// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.25 13.75C4.8 13.75 4.38 13.57 4.06 13.25L2.25 11.44C1.54 10.73 1.54 9.57 2.25 8.86L8.81 2.3C9.52 1.59 10.68 1.59 11.39 2.3L13.7 4.61C14.41 5.32 14.41 6.48 13.7 7.19L7.14 13.75H5.25Z',
  'M4.35 6.76L4.9 7.56C5.78 8.86 6.9 9.98 8.2 10.86L9.51 11.38M7.14 13.75H14',
];
